import { render, staticRenderFns } from "./QuotaItem.vue?vue&type=template&id=6da72961&scoped=true"
import script from "./QuotaItem.vue?vue&type=script&lang=js"
export * from "./QuotaItem.vue?vue&type=script&lang=js"
import style0 from "./QuotaItem.vue?vue&type=style&index=0&id=6da72961&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da72961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da72961')) {
      api.createRecord('6da72961', component.options)
    } else {
      api.reload('6da72961', component.options)
    }
    module.hot.accept("./QuotaItem.vue?vue&type=template&id=6da72961&scoped=true", function () {
      api.rerender('6da72961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/QuotaItem.vue"
export default component.exports